export const SET_FILTROS = 'FILTROS/SET_FILTROS'
export const LIMPAR_FILTROS = 'FILTROS/LIMPAR_FILTROS'

export const SET_ORDENACAO = 'FILTROS/SET_ORDENACAO'
export const LIMPAR_ORDENACAO = 'FILTROS/LIMPAR_ORDENACAO'
